import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, BaseContainerService, NotificationService } from 'yt-ng-framework';
//import { NotifierService } from 'angular-notifier';
// import { NotificationsService } from 'angular2-notifications';
import { OsnovZaGo } from './osnov-za-go';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-osnov-za-go-update',
  templateUrl: './osnov-za-go-update.component.html'
})
export class OsnovZaGoUpdateComponent 
extends BaseUpdateComponent<OsnovZaGo> 
implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc('Naziv', Validators.required, 'required', 'OSNOVZAGO.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc('Naziv', Validators.maxLength(50), 'maxlength', 'OSNOVZAGO.NAZIV.VALIDATION.MAXLENGTH');
  }


}
